import { graphql } from '@/gql/codegen/gql';
import { useMutation } from '@apollo/client';
import { useCallback } from 'react';

export const START_SKILL_CHECK_TEST_MUTAION = graphql(/* GraphQL */ `
  mutation EmbaStartSkillCheckTest(
    $input: StartCourseSkillCheckTestMutationInput!
  ) {
    embaStartCourseSkillCheckTest(input: $input) {
      embaUserCourseSkillCheckTestResult {
        id
      }
    }
  }
`);

export const useStartSkillCheckTestMutation = (
  embaUserAttendanceSlug: string,
  setEmbaUserCourseSkillCheckTestResultId: (id: number) => void,
) => {
  const [
    startSkillCheckTestMutation,
    {
      error: startSkillCheckTestMutationError,
      loading: startSkillCheckTestMutationLoading,
    },
  ] = useMutation(START_SKILL_CHECK_TEST_MUTAION);

  const startSkillCheckTest = useCallback(async (): Promise<void> => {
    const response = await startSkillCheckTestMutation({
      variables: {
        input: {
          embaUserAttendanceSlug,
        },
      },
    });
    const result_id =
      response.data?.embaStartCourseSkillCheckTest
        ?.embaUserCourseSkillCheckTestResult?.id;

    if (result_id) {
      setEmbaUserCourseSkillCheckTestResultId(result_id);
    }
  }, [
    embaUserAttendanceSlug,
    setEmbaUserCourseSkillCheckTestResultId,
    startSkillCheckTestMutation,
  ]);

  return {
    startSkillCheckTest,
    startSkillCheckTestMutationError,
    startSkillCheckTestMutationLoading,
  };
};
